export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'expand',
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzFtyNoticeOutNo') || '出库通知单',
    field: 'amzFtyNoticeOutNo',
    align: 'center',
    minWidth: 150,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amazonStoreRegion') || '店铺区域',
    field: 'v_amazonStoreRegion',
    align: 'center',
    minWidth: 100,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totalGoodsQty') || '出货数量',
    field: 'totalGoodsQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalCtnQty') || '出货箱数',
    field: 'totalCtnQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_shipmentByFactory') || '是否工厂发货',
    field: 'v_shipmentByFactory',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ecomWarehouseName') || '出库仓库',
    field: 'ecomWarehouseName',
    align: 'center',
    minWidth: 220,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_batchDeliveryDate') || '出货日期',
    field: 'deliveryDate',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_bookContractNo') || '外运编号',
    field: 'bookContractNo',
    align: 'center',
    minWidth: 150,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_batchModifyTime') || '出库时间',
    field: 'modifyTime',
    align: 'center',
    minWidth: 160,
    showOverflow: true,
    showHeaderOverflow: true,
  },
]
